import { useStore } from '@nanostores/react'
import clsx from 'clsx'
import { CustomTip } from 'components/atoms/tooltipCustom'
import { ContactInfoCells } from 'features/contacts/ui/GeneralTable/InfoCells'
import { getLinkedInId } from 'features/contacts/utils'
import { $executionsColumns, Column } from 'features/contacts/utils/columns'
import { memo } from 'react'
import { ContactsTable } from 'shared/ui'

import type { Execution } from '../../types'

import { colorByStep } from '../../utils'
import { Info } from '../Actions/Info'
import { LinkedLink } from '../Actions/LinkedLink'
import { Message } from '../Actions/Message'
import { Stop } from '../Actions/Stop'
import statusCss from './Status.module.css'

export type ExecRowProps = {
	data: Execution
}

function InfoCells(execution: Execution) {
	const columns = useStore($executionsColumns)
	return columns.map(key => {
		if (key === Column.Status) {
			return <Status {...execution} key={key} />
		}

		const adapted = {
			...execution.linkedin_contact,
			created: execution.created
		}

		return <ContactInfoCells column={key} key={key} {...adapted} />
	})
}

function Status({ human_state: state, step_executions: steps }: Execution) {
	return (
		<td className={clsx(ContactsTable.css.cell, statusCss.root)}>
			{steps.map((step, key) =>
				step.is_visible ? (
					<CustomTip arrow key={key} title={step.hint}>
						<span
							className={statusCss.item}
							style={{
								background: `${colorByStep(state, step)}`
							}}
						/>
					</CustomTip>
				) : null
			)}
		</td>
	)
}

const Actions = (execution: Execution) => (
	<td className={ContactsTable.css.actions}>
		<div className={ContactsTable.css.actionsWrap}>
			<Info
				{...execution.actions.show_details}
				campaignId={execution.campaign_id}
				humanState={execution.human_state}
				id={execution.id}
				key='ℹ️'
				state={execution.state}
				steps={execution.step_executions}
			/>
			<LinkedLink
				{...execution.actions.open_linkedin_profile}
				id={getLinkedInId(execution.linkedin_contact)}
				key='⛓️‍💥'
			/>

			<Message
				{...execution.actions.open_conversation}
				id={execution.conversation_id}
				key='🗨️'
			/>

			<Stop {...execution.actions.complete} id={execution.id} key='🛑' />
		</div>
	</td>
)

const Cells_ = (execution: Execution) => [
	<InfoCells key='ℹ️' {...execution} />,
	<Actions key='▶️' {...execution} />
]

export const Cells = memo(Cells_)

export { Status }
